import { Dict } from '/imports/types';

export const Subscriptions: Dict<() => boolean> = {};

/**
 * Registers a named subscription readiness predicate.
 * @param name - subscription key
 * @param sub - predicate returning whether the subscription is ready
 */
export const registerSubscription = (name: string, sub: () => boolean) => {
  Subscriptions[name] = sub;
};